angular.module('controllers').controller('homeController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, $http, Crud, $mdDialog, $route, $routeParams, $location) {
		$rootScope.path = '/home';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'home';
    $rootScope.modelNameStatistic = 'statistic';
		$scope.pathTemplate = 'app/home';
		$scope.title = 'Home Page';
    $rootScope.typeId = 'id';
    $scope.defaultItem = 10;

		angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.additionals['publicPath'] = '/images/app';
        $scope.additionals['jsonPath'] = '/json';

        $scope.order_source = {};
        $scope.order_source.options = [
            {'id': '', 'value' : ''},
            {'id': 0, 'value': 'Directa', 'icon': $scope.additionals['publicAppPath'] + '/direct.png'},
            {'id': 1, 'value': 'Telefon', 'icon' : $scope.additionals['publicAppPath']+'/phone.png'},
            {'id': 2, 'value':  $rootScope.nameProject, 'icon' : $scope.additionals['publicAppPath']+'/logo_ssmall.png'},
            {'id': 3, 'value': 'HipMenu', 'icon' : $scope.additionals['publicAppPath']+'/hipmenu.png'},
            {'id': 4, 'value': 'FoodPanda', 'icon' : $scope.additionals['publicAppPath']+'/foodpanda.png'},
            {'id': 5, 'value': 'Tazz', 'icon': $scope.additionals['publicAppPath'] + '/tazz.png'},
            {'id': 6, 'value': 'Glovo', 'icon': $scope.additionals['publicAppPath'] + '/glovo.png'},
            {'id': 7, 'value': 'Takeaway', 'icon': $scope.additionals['publicAppPath'] + '/takeaway.png'}
        ];

        $scope.additionals['getLimitedStatistic'] = function () {
            Crud.get('statistic/getLimitedStatistic')
                .success(function (data) {
                    //console.log(data)
                    $scope.additionals['statisticsPreviousDate'] = data[data.length - 1];

                    /* previous date */
                    if (!angular.isUndefined($scope.additionals['statisticsPreviousDate'])) {
                        $scope.additionals['getCoordinates']();

                        /* charts */
                        $scope.chartsOptionsPrevious = {
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                display: true,
                                position: 'right',
                                labels: {
                                    boxWidth:12,
                                    fontSize:11,
                                    padding:5
                                }
                            },
                            layout: {
                                padding: {
                                    left: 20,
                                    right: 20,
                                    top: 20,
                                    bottom: 20
                                }
                            },
                            tooltips: {
                                titleFontSize: 12,
                                bodyFontSize: 11
                            },
                            plugins: {
                                legend: true,
                                outlabels: {
                                    text: '%l %p',
                                    color: 'white',
                                    stretch: 10,
                                    padding: 2,
                                    percentPrecision: 2,
                                    valuePrecision: 4,
                                    font: {
                                        resizable: true,
                                        minSize: 10,
                                        maxSize: 12
                                    }
                                },
                                labels: [
                                    /*{
                                        render: 'label',
                                        position: 'outside',
                                        textMargin: 14,
                                        //arc: true
                                    },*/
                                    {
                                         render: 'percentage',
                                        /*render: function (args) {
                                            if(Number.isNaN(args.percentage)){ args.percentage = 0;}
                                            return args.percentage+'%';
                                        },*/
                                        //precision: 2,
                                    }

                                ]
                            }
                        };
                        $scope.chartsDataShipping = $scope.additionals['statisticsPreviousDate']['shippings_orders'].map(function (item, index) {
                            return parseFloat(item.value_orders);
                        });
                        $scope.chartsLabelsShipping = $scope.additionals['statisticsPreviousDate']['shippings_orders'].map(function (item, index) {
                            return item['shipping_method_name'];
                        });

                        $scope.chartsDataSource = $scope.additionals['statisticsPreviousDate']['sources_orders'].map(function (item, index) {
                            return parseFloat(item.value_orders);
                        });
                        $scope.chartsLabelsSource = $scope.additionals['statisticsPreviousDate']['sources_orders'].map(function (item, index) {
                            return $scope.additionals['associativeColumn']($scope.order_source, parseInt(item['id']));
                        });
                        /* end previous date */

                        $scope.chartsDataNos = [data.map(function (item, index) {
                            return parseFloat(item.nos_orders);
                        })];
                        $scope.chartsLabelsNos = data.map(function (item, index) {
                            return item['date'];
                        });
                        $scope.datasetOverrideNos = [
                            {
                                //backgroundColor: 'rgba(151,187,205,0.5)',
                                label: 'Nr. comenzi',
                                borderWidth: 3,
                                borderColor: "rgba(247, 70, 74, 1)",
                                backgroundColor: 'rgba(241,225,48,0)',
                                hoverBackgroundColor: "rgba(193, 32, 38, 0.5)",
                                hoverBorderColor: "rgba(193, 32, 38, 1)",
                            }
                        ];
                        $scope.chartsOptionsNos = {
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                display: false,
                                position: 'bottom',
                                labels: {
                                    boxWidth:12,
                                    fontSize:11,
                                    padding:5
                                }
                            },
                            layout: {
                                padding: {
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0
                                }
                            },
                            tooltips: {
                                titleFontSize: 12,
                                bodyFontSize: 11
                            },
                            plugins: {
                                legend: true,
                                labels: [
                                    {
                                        render: 'value',
                                        precision: 2
                                    }
                                ]
                            }
                        };
                        $scope.chartsOptionsNos.scales = {
                            yAxes: [
                                {
                                    id: 'y-axis-1',
                                    type: 'linear',
                                    display: true,
                                    position: 'left',
                                    gridLines: {
                                        display: true,
                                        drawBorder: true,
                                        drawOnChartArea: false,
                                    }
                                }
                            ],
                            xAxes: [
                                {
                                    gridLines: {
                                        display: true,
                                        drawBorder: true,
                                        drawOnChartArea: false,
                                    }
                                }
                            ]
                        };

                        $scope.chartsSeriesValues = ['Total comenzi', 'Taxa livrare', 'Discount'];
                        $scope.chartsDataValues = [
                            data.map(function (item, index) {
                                return parseFloat(item['values_orders']);
                            }),
                            data.map(function (item, index) {
                                return parseFloat(item['shipping_values_orders']);
                            }),
                            data.map(function (item, index) {
                                return parseFloat(item['discount_values_orders']);
                            })
                        ];
                        $scope.chartsLabelsValues = data.map(function (item, index) {
                            return item['date'];
                        });
                        $scope.chartsOptionsValues = {
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                display: false,
                                position: 'bottom',
                                labels: {
                                    boxWidth:12,
                                    fontSize:11,
                                    padding:5
                                }
                            },
                            layout: {
                                padding: {
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0
                                }
                            },
                            tooltips: {
                                titleFontSize: 12,
                                bodyFontSize: 11
                            },
                            plugins: {
                                legend: true,
                                labels: [
                                    {
                                        render: 'value',
                                    }
                                ]
                            }
                        };
                        $scope.chartsOptionsValues.scales = {
                            yAxes: [
                                {
                                    id: 'y-axis-1',
                                    type: 'linear',
                                    display: true,
                                    position: 'left',
                                    gridLines: {
                                        display: true,
                                        drawBorder: true,
                                        drawOnChartArea: false,
                                    }
                                }
                            ],
                            xAxes: [
                                {
                                    gridLines: {
                                        display: true,
                                        drawBorder: true,
                                        drawOnChartArea: false,
                                    }
                                }
                            ]
                        };
                        $scope.chartsOptionsValues.plugins = {
                            labels: [
                                {
                                    // render: 'percentage',
                                    render: function (args) {
                                        if(Number.isNaN(args.percentage)){ args.percentage = 0;}
                                        return args.percentage+'%';
                                    },
                                    precision: 2,
                                }
                            ]
                        };
                        /* end charts */

                    }

                });
        }
        if($scope.permissions == 'all' || (!angular.isUndefined($scope.permissions['statistic.getlimitedstatistic']) && $scope.permissions['statistic.getlimitedstatistic'] == true)) {
            $scope.additionals['getLimitedStatistic']();
        }

        $scope.center = [46.779608, 23.593165];
        $scope.initMap = function (data) {
            var OpenStreetMap = L.tileLayer(
                'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                {maxZoom: 11.7, type: 'osm', opacity: 0}
            );
            var LocalOpenStreet = L.tileLayer(
                'https://api.947.ro:8081/tiles/{z}/{x}/{y}.png',
                {maxZoom: 12, type: 'osm_local', opacity: 1}
            );

            if (!$scope.map || $scope.map == undefined) {
                $scope.map = L.map('map-home', {
                    center: $scope.center,
                    zoom: 13,
                    scrollWheelZoom: false,
                    zoomControl: false,
                    attributionControl: false,
                    layers: [OpenStreetMap],
                });
                /*$scope.map.flyTo($scope.center, 14, {
                     animate: true,
                     duration: 3
                  });*/
                $scope.map.dragging.disable();

                var sections = data;

                angular.forEach(sections, function (itemSection, keySection) {
                    if (!angular.isUndefined(itemSection['coordinates'])) {
                        var polygon = L.polygon(itemSection['coordinates'], {color: 'red'}).addTo($scope.map);
                        $scope.map.fitBounds(polygon.getBounds());

                        polygon.setStyle({
                            'fillColor': '#A0A0A0',
                            'weight': 0.1,
                            'opacity': 1
                        });

                        var positionSectionLocality = $scope.additionals['statisticsPreviousDate']['sections_orders'].map(function (e) {
                            if(e['section_id'] == '0'){
                                return e['locality_name'];
                            } else {
                                return e['section_name'];
                            }
                        }).indexOf(itemSection['label']);
                        if (positionSectionLocality >= 0) {
                            var no_orders = $scope.additionals['statisticsPreviousDate']['sections_orders'][positionSectionLocality]['no_orders'];
                            var value_orders = $scope.additionals['statisticsPreviousDate']['sections_orders'][positionSectionLocality]['value_orders'];
                        } else {
                            var no_orders = 0;
                            var value_orders = 0;
                        }
                        polygon.bindTooltip(itemSection['label'] + '<br><center>'+no_orders+'</center>',
                            {permanent: true, direction: 'center', className: 'leaflet-polygon'}
                        ).openTooltip();

                        var popup = '<center>' + itemSection['label'] + '</center>' +
                            '<span class="font11">Nr. comenzi:'+no_orders+'</span>' +
                            '<br><span class="font11">Total comenzi:'+value_orders+' lei</span>';
                        polygon.bindPopup(popup);
                        polygon.on('mouseover', function (e) {
                            polygon.setStyle({
                                'fillColor': 'yellow',
                                'weight': 0.5,
                                'opacity': 1
                            });
                            this.openPopup();
                            /*var popup = L.popup()
                            .setLatLng(e.latlng)
                            .setContent('Popup')
                            .openOn($scope.map);*/
                        });
                        polygon.on('mouseout', function (e) {
                            polygon.setStyle({
                                'fillColor': 'rgba(0,51,153, .6)',
                                'weight': 0.5,
                                'opacity': 1
                            });
                            //this.closePopup();
                        });
                    }
                });

            }

        }

        $scope.additionals['getCoordinates'] = function () {
            Crud.get($scope.additionals['jsonPath'] + '/coordinates.json')
                .success(function (data) {
                    $scope.initMap(data);
                });
        }








	}]
)
